export const TABLET_BREAK_POINT = 768
export const SMALL_PC_BREAK_POINT = 1024
export const NORMAL_PC_BREAK_POINT = 1280
